import axios from 'axios'
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'

export async function assingLeadAuto() {
    try {
        const res = await axios.post(`${LEADS_ENDPOINT}/searchAndAssignation`)
        return res.data.assignedLead
    } catch {
        throw new Error()
    }
}
